export class TaskAccumulationPeriod {
	constructor() {
	}
} 
